import { Flex, LoadingIndicator } from '@qga/roo-ui/components';
import { SubmitHandler, useForm } from 'react-hook-form';
import styled from '@emotion/styled';
import { noop } from 'lodash';
import { RequestCallbackDetails } from './RequestCallbackDetails';
import { RequestCallbackConfirmation } from './RequestCallbackConfirmation';
import type { FC } from 'react';

const Form = styled('form')`
  position: relative;
`;

const Overlay = styled(Flex)`
  align-items: center;
  justify-content: center;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  position: absolute;
  background-color: rgba(255, 255, 255, 0.7);
`;

export interface CallbackFormFieldValues {
  fullName: string;
  phoneNumber: string;
  qffNumber?: string;
  callbackTime?: string;
  callbackDate?: string;
}

export type PrefillableFields = Partial<
  Omit<CallbackFormFieldValues, 'callbackTime' | 'callbackDate'>
>;

type RequestCallbackFormProps = {
  onSubmit?: SubmitHandler<CallbackFormFieldValues>;
  onClose?: () => void;
  isSubmitting?: boolean;
  isComplete?: boolean;
  prefilledDetails?: PrefillableFields;
};

export const RequestCallbackForm: FC<RequestCallbackFormProps> = ({
  onSubmit = noop,
  onClose = noop,
  isSubmitting = false,
  isComplete = false,
  prefilledDetails,
}) => {
  const {
    handleSubmit,
    register,
    formState: { errors },
  } = useForm<CallbackFormFieldValues>({
    mode: 'onBlur',
  });

  return (
    <Form onSubmit={handleSubmit(onSubmit)}>
      {isSubmitting && (
        <Overlay>
          <LoadingIndicator color="greys.steel" />
        </Overlay>
      )}
      {!isComplete && (
        <RequestCallbackDetails
          register={register}
          errors={errors}
          prefilledDetails={prefilledDetails}
        />
      )}
      {isComplete && <RequestCallbackConfirmation onClose={onClose} />}
    </Form>
  );
};
